export default function selectJiraAreComponentsLoading(state, { source }) {
  return state.integrations.thirdPartyData[source].components.loading
}
